<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!orgUnit"></page-loading>
            <template v-else>
                <org-unit-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :org-unit="orgUnit"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <org-unit-proforma-invoices
                    v-if="orgUnit.is_billable"
                    v-show="hash === 'proforma-invoices'"
                    :team-id="teamId"
                    :org-unit-id="orgUnit.id"
                    :payment-terms-days="orgUnit.payment_terms_days"
                />

                <org-unit-historical-invoices
                    v-show="hash === 'historical-invoices'"
                    :team-id="teamId"
                    :org-unit-id="orgUnit.id"
                />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import OrgUnitBillingDetails from '~/components/settings/teams/org-units/billing/OrgUnitBillingDetails.vue';
import OrgUnitProformaInvoices from './OrgUnitProformaInvoices.vue';
import OrgUnitHistoricalInvoices from './OrgUnitHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, computed, watch, nextTick, onMounted } from 'vue';
import { useBrowserLocation } from '@vueuse/core';
import { orgUnitsClient } from '~/services';

const location = useBrowserLocation();
const hash = computed(() => location.value.hash?.replace('#/', '').replace('#', ''));

const content = ref();
const orgUnit = ref(null);

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const isAdminOrOwner = Spark.isAdminOrOwner || Spark.roleOnCurrentOrgUnit === 'admin';

const getOrgUnit = async () => {
    try {
        const response = await orgUnitsClient.showOrgUnit(props.teamId, props.orgUnitId);
        orgUnit.value = response.data;
    } catch (error) {
        console.error('Failed to fetch org unit:', error);
    }
};

onMounted(() => {
    getOrgUnit();
});

watch(
    hash,
    async () => {
        await nextTick();
        if (!content.value || window.innerWidth >= 768) {
            return;
        }
        content.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    { immediate: true }
);
</script>
